
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galxe",
      function () {
        return require("private-next-pages/galxe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galxe"])
      });
    }
  